<template>
  <div>
    <courseRecordOverview :instructorCoursesProps="instructorCoursesData" />
  </div>
</template>

<script>
import courseRecordOverview from "../../../components/adminComponent/coursemanagement/coursecordoverview/courseRecordOverview";
import { mapGetters } from "vuex";

export default {
  name: "CoursesOverview",
  components: {
    courseRecordOverview,
  },
  data() {
    return {
      instructorCoursesData: [],
    };
  },
  computed: {
    ...mapGetters({
      instructorCoursesGetter: "courses/getInstructorsCourse",
      v3IsTeaching:"v3/v3IsTeaching"
    }),
  },
  watch: {
    instructorCoursesGetter(value) {
      console.log('value value value', value);
      this.instructorCoursesData = value;
      if (value && value.length > 0) {
        this.$store.commit("necessary/setInstructorSection", this.instructorCoursesData[0].section);
      }
    },
    v3IsTeaching(value) {
      console.log('v3IsTeaching v3IsTeaching v3IsTeaching', value);
      this.instructorCoursesData = value;
      if (value && value.length > 0) {
        this.$store.commit("necessary/setInstructorSection", this.instructorCoursesData[0].section);
      }
    },
  },
  created() {
    
  },
  mounted() {
    this.fetchCourses();
  },
  methods: {
    fetchCourses() {
      // this.$store.commit("v3/v3ClearTeaching");
      this.$store.commit("language/setChangingSidebar", true);
      // this.$store.dispatch("courses/fetchInstructorsCourse");
      this.$store.dispatch("v3/v3IsTeaching");
      
    },
  },
};
</script>

<style>
</style>